import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { StickyBar } from './components/StickyBar';
import { HeroSection } from './components/HeroSection';
import { Section1 } from './components/Section1';
import { Section2 } from './components/Section2';
import { Section3 } from './components/Section3';
import { Section4 } from './components/Section4';
import { Section5 } from './components/Section5';
import { Section6 } from './components/Section6';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-ivory font-sans text-dark selection:bg-gold selection:text-white" data-id="element-0">
      <StickyBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <Section1 data-id="element-4" />
        <Section2 data-id="element-5" />
        <Section3 data-id="element-6" />
        <Section4 data-id="element-7" />
        <Section5 data-id="element-8" />
        <Section6 data-id="element-9" />
        <FinalCTA data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}